import styled from "styled-components";
import { collectionbgimg1 } from "assets";

export const MainSection = styled.section``;

export const MainWrapper = styled.div`
  margin-top: 3rem;
  margin-bottom: 6rem;

  @media (max-width: 767px) {
    margin-top: 1.5rem;
  }
`;

export const TextBoxDiv = styled.div`
  margin-top: 2rem;
  position: relative;
  width: 37.5625rem;
  height: 5.5rem;

  @media (max-width: 1600px) {
    width: 25.5625rem;
  }

  @media (max-width: 600px) {
    width: 300px;
  }

  img {
    width: 100% !important;
    height: 100% !important;
  }

  div {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 2rem;
    h1 {
      margin: 0;
      color: #fff;
      font-size: 50px;
      font-style: italic;
      font-weight: 400;
      line-height: 77px;
      letter-spacing: -0.02em;

      span {
        color: rgba(247, 193, 58, 1);
        font-family: "Space Crusaders" !important ;
      }

      @media (max-width: 1600px) {
        font-size: 2.125rem;
      }
      @media (max-width: 767px) {
        font-size: 1.74063rem;
      }
    }
  }
`;

export const ImgWrapper = styled.div`
  margin-top: 2rem;

  @media (max-width: 990px) {
    margin-top: 0rem;
  }
  img {
    width: 100%;
  }

  video {
    width: 100%;
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 590px;

  @media (max-width: 767px) {
    min-height: 430px;
  }

  .innerimg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 767px) {
    margin-top: 3rem;
  }
`;

export const CardInnerDiv = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 2rem 3rem;

  @media (max-width: 767px) {
    padding: 2rem 2rem;
  }
  h1 {
    font-size: 42px;
    font-style: italic;
    font-weight: 400;
    line-height: 77px;
    letter-spacing: -0.02em;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    /* margin-top: 2rem; */

    span {
      font-family: "Space Crusaders" !important ;
      color: rgba(247, 193, 58, 1);
    }

    @media (max-width: 1550px) {
      font-size: 30.273px;
    }

    @media (max-width: 1250px) {
      font-size: 20px;
    }

    @media (max-width: 767px) {
      font-size: 25.273px;
    }
  }

  .content-div {
    display: flex;
    align-items: center;
    gap: 0.8rem;

    @media (max-width: 767px) {
      margin-top: 1.2rem;
    }

    h5 {
      font-size: 19px;
      font-style: italic;
      font-weight: 600;
      line-height: 49px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 1);
      margin: 0;
      @media (max-width: 1600px) {
        font-size: 19px;
      }

      @media (max-width: 1550px) {
        font-size: 17px;
      }

      @media (max-width: 1400px) {
        font-size: 15px;
      }

      @media (max-width: 1310px) {
        font-size: 13px;
      }

      @media (max-width: 767px) {
        font-size: 15px;
        line-height: 20px;
      }
    }
  }

  .price-div {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1250px) {
      img {
        width: 100px;
      }
    }

    h1 {
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 29px;
      letter-spacing: 0em;
      color: rgba(236, 195, 49, 1);
      margin: 0;

      @media (max-width: 1250px) {
        font-size: 20px;
      }

      @media (max-width: 767px) {
        font-size: 15.636px;
      }
    }
    p {
      font-size: 24px;
      font-style: italic;
      font-weight: 600;
      line-height: 49px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 1);
      margin: 0;

      @media (max-width: 1250px) {
        font-size: 20px;
      }

      @media (max-width: 767px) {
        font-size: 15.636px;
        line-height: 30px;
      }
    }
  }

  .register-btn-div {
    cursor: pointer;
    position: relative;
    width: 249px;
    height: 64.17px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.5rem;

    @media (max-width: 767px) {
      width: 141.477px;
      height: 36.461px;
      margin-top: 1rem;
    }
    h1 {
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 29px;
      letter-spacing: 0em;
      color: rgba(51, 29, 1, 1);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 100%;
      @media (max-width: 767px) {
        font-size: 14px;
      }
    }

    .btn-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .card-data {
    margin-top: 2rem;

    @media (max-width: 767px) {
      margin-top: 1.5rem;
    }
  }

  @media (max-width: 767px) {
    .space-img {
      width: 88.068px;
      height: 12.825px;
    }
  }
`;
